import { createFileRoute } from '@tanstack/react-router';

import { agentTraceDetailSearchSchema } from '@apps/web/routes/_app/admin/agent-traces/search_params';

export const Route = createFileRoute(
    '/_app/admin/agent-traces/$conversationId',
)({
    head: () => ({ meta: [{ title: 'Agent Trace Detail' }] }),
    validateSearch: agentTraceDetailSearchSchema,
});
